function AdditionalActivities() {
  return <h1>Additional Activities</h1>;
}

export default AdditionalActivities;